import { Component, Vue } from "vue-property-decorator";

import { STHeader,STFooter } from "@/layout";
import { QuizModel } from "@/models";
import { StCommon } from "../Common";

export class SearchForm {
    date = '';
    name = '';
}

type response = { [key: string]: unknown };

@Component<ApStudentTestResultController>({
    components: {
        STHeader,STFooter
    }
})
export default class ApStudentTestResultController extends Vue {
    private searchForm = new SearchForm();
    private resultList: object = {};
    private num = 0;
    private page = 1;
    private perpage = 50;
    private maxPage = 0;
    private stid = window.localStorage.getItem('student_stid') as string;
    private token = window.localStorage.getItem('studentToken') as string;

    public created() {
        this.getResultList();
    }

    public async getResultList() {
        const item = {
            page: this.page,
            perpage: this.perpage,
            date: this.searchForm.date,
            name: this.searchForm.name,
            stid: this.stid,
            token: this.token,
        }
        const data = await QuizModel.stGetResultList(item) as response;
        StCommon.checkToken(data.ERR_CODE as number);
        this.num = data.num as number;
        this.resultList = data.list as object;
        this.maxPage = Math.ceil(this.num/this.perpage);
    }

    private getPageList(page: number) {
        this.page = (page < 1) ? 1 : (page > this.maxPage) ?  this.maxPage : page;
        this.getResultList();
    }
}